import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { DEFAULT_ROUTE_CREATE, IRouteCreate } from "../../../models/route";
import routeService from "../../../services/routeService/RouteService";
import RouteFormPage from "../../../components/routes/RouteFormPage";

const RouteAddPage = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const onCreateRoute = async (payload: IRouteCreate) => {
        setErrorMessage(null);

        try {
            const createdRouteId = await routeService.PostRoute(payload);
            if (createdRouteId) navigate("..");
        } catch {
            setErrorMessage(t("table.route.createError"));
        }
    };

    return (
        <RouteFormPage
            mode="create"
            initialValues={DEFAULT_ROUTE_CREATE}
            errorMessage={errorMessage}
            onSubmit={onCreateRoute}
            onCancel={() => navigate("..")}
        />
    );
};

export default RouteAddPage;